<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-dialog
      v-model="intDialogVisible"
      persistent
      width="auto "
      max-width="400"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title class="headline">{{
          $t("HomePage.header.revoke")
        }}</v-card-title>

        <v-spacer></v-spacer>

        <v-card-text>
          {{ $t("HomePage.revoke_text") }}

          <v-spacer></v-spacer>

          <v-textarea
            v-model="refuseText"
            class="text-input"
            filled
            prepend-inner-icon="mdi-pencil"
            :label="$t('HomePage.revoke_area')"
          ></v-textarea>
        </v-card-text>

        <v-spacer></v-spacer>

        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            :text="$t('Headers.cancel')"
            @click="cancel"
          ></custom-button>
          <custom-button
            :text="$t('Headers.save')"
            :loading="loading"
            @click="revoke"
          ></custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import HeaderMedium from "../text/HeaderMedium";
import CustomButton from "./CustomButton";
import { log } from "../../../helpers/logger";

export default {
  name: "revoke-dialog",
  data() {
    return {
      refuseText: "",
    };
  },
  props: {
    dialog: Boolean,
  },
  components: {
    HeaderMedium,
    CustomButton,
  },
  computed: {
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
    intDialogVisible: {
      get: function () {
        return this.dialog;
      },
      set: function (value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      refuseText: "",
    };
  },
  methods: {
    revoke() {
      this.loading = true;
      this.$store
        .dispatch("data/revokeWorkflow", {
          workflow_id: this.currentWorkflow.workflow_id,
          signer_id: this.currentWorkflow.signer_id,
          msg: this.refuseText,
        })
        .finally(() => {
          log(
            "ui.input.RevokeDialog.revoke() - Revoke workflow " +
              this.currentWorkflow.workflow_id +
              " for signer " +
              this.currentWorkflow.signer_id,
            "info"
          );
          this.$router.push("/summary/revoked");
        })
        .catch((err) => {
          this.loading = false;
          this.refuseText = "";
          log("ui.input.RevokeDialog.revoke() - " + err, "error");
        });
    },
    cancel() {
      this.$emit("cancel", true);
    },
  },
};
</script>